export default __webpack_public_path__ + "static/media/tools.ad37747f.png";